import { CommandType } from '../../shared/types';
import type { HudManager } from '../ui/HudManager';
import type { InputSender } from '../networking/InputSender';

/**
 * Connect HUD UI callbacks (card click/discard, drone select, leader, ability)
 * to the InputSender command queue. Pure wiring — no DOM or Three.js access.
 */
export function wireUiCommands(
  hud: HudManager,
  inputSender: InputSender,
  abilityDirectionProvider?: () => { x: number; y: number; z: number },
): void {
  const cardBar = hud.getCardBar();
  cardBar.onCardActivate((slot) => {
    inputSender.queueCommand({ type: CommandType.ActivateCard, cardSlot: slot });
  });
  cardBar.onCardDiscard((slot) => {
    inputSender.queueCommand({ type: CommandType.DiscardCard, cardSlot: slot });
  });

  const droneStatus = hud.getDroneStatus();
  droneStatus.onDroneSelect((droneId, additive) => {
    inputSender.queueCommand({ type: CommandType.SelectDrone, droneId, additive });
  });
  droneStatus.onSetLeader((droneId) => {
    inputSender.queueCommand({ type: CommandType.SetLeader, droneId });
  });
  droneStatus.onTriggerAbility((droneId) => {
    const direction = abilityDirectionProvider?.();
    inputSender.queueCommand({ type: CommandType.TriggerAbility, droneId, ...(direction ? { direction } : {}) });
  });
  droneStatus.onDismissDrone((droneId) => {
    inputSender.queueCommand({ type: CommandType.DismissDrone, droneId });
  });
}
